import React from 'react';
import '../template-file-css/document-file-template.css';


export const EYPC_QuarterlyProgressReview = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EYPC_QuarterlyProgressReview' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <h3>QUARTERLY PROGRESS REVIEW</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>QUARTERLY PROGRESS REVIEW FOR:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtQUARTERLYPROGRESSREVIEWFOR' name='txtQUARTERLYPROGRESSREVIEWFOR' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>A Quarterly Progress Review was created or reviewed today on:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtAQuarterlyProgressReviewWasCreatedOrReviewedTodayOn' name='txtAQuarterlyProgressReviewWasCreatedOrReviewedTodayOn' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    The ISP, PERSON CENTER GOALS and SAFETY PLAN were <b> {`*REVIEWED*`} </b>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>This was a QUARTERLY PROGRESS Meeting. Participating Plan Attendees:</span>
                            <span className='small'>(Individual, Guardian, QMHP NAME, LMHP NAME)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>1.</td>
                        <td className='w-730'> <input type='text' id='txtThisWasQuarterlyProgressMeetingParticipating_1' name='txtThisWasQuarterlyProgressMeetingParticipating_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>2.</td>
                        <td className='w-730'> <input type='text' id='txtThisWasQuarterlyProgressMeetingParticipating_2' name='txtThisWasQuarterlyProgressMeetingParticipating_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>3.</td>
                        <td className='w-730'> <input type='text' id='txtThisWasQuarterlyProgressMeetingParticipating_3' name='txtThisWasQuarterlyProgressMeetingParticipating_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>4.</td>
                        <td className='w-730'> <input type='text' id='txtThisWasQuarterlyProgressMeetingParticipating_4' name='txtThisWasQuarterlyProgressMeetingParticipating_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Diagnosis:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>1.</td>
                        <td className='w-730'> <input type='text' id='txtDiagnosis_1' name='txtDiagnosis_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>2.</td>
                        <td className='w-730'> <input type='text' id='txtDiagnosis_2' name='txtDiagnosis_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>3.</td>
                        <td className='w-730'> <input type='text' id='txtDiagnosis_3' name='txtDiagnosis_3' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Current Medications:</h3>
                    <span className='small'>(include changes to medications)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-225'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Dosage</span></td>
                        <td className='w-150'><span className='eleHeader'>Frequency</span></td>
                        <td className='w-225'><span className='eleHeader'>Change to Medications</span></td>
                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtMedication_1' name='txtMedication_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' />
                        </td>
                        <td className='w-225'>
                            <input type='text' id='txtChangeToMedications_1' name='txtChangeToMedications_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtMedication_2' name='txtMedication_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' />
                        </td>
                        <td className='w-225'>
                            <input type='text' id='txtChangeToMedications_2' name='txtChangeToMedications_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtMedication_3' name='txtMedication_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' />
                        </td>
                        <td className='w-225'>
                            <input type='text' id='txtChangeToMedications_3' name='txtChangeToMedications_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtMedication_4' name='txtMedication_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' />
                        </td>
                        <td className='w-225'>
                            <input type='text' id='txtChangeToMedications_4' name='txtChangeToMedications_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-225'>
                            <input type='text' id='txtMedication_5' name='txtMedication_5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_5' name='txtDosage_5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' />
                        </td>
                        <td className='w-225'>
                            <input type='text' id='txtChangeToMedications_5' name='txtChangeToMedications_5' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>OVERVIEW OF FAMILY INVOLVEMENT TO ASSIST INDIVIDUAL IN MEETING GOALS/TRAINING:</h3>
                    <span className='small'>(Family Sessions, Co-Parenting, 504 Plan Meetings, FAPT, CHINS , LEGAL etc.)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Describe Care Coordination Activities with external resources and providers since the last authorization:</span>
                            <span className='small'>(LIST Names AND CONTACT information: Outpatient therapists, psychiatrists, psychologists, PCP, School, Social, Sports, or Community Activities
                                and from MCC)</span>
                            <span className='small'>(Describe adherence to External Providers since last authorization AND list providers)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>1.</td>
                        <td className='w-730'> <input type='text' id='txtOverviewFamilyInvolvementAssistIndividualMeetingGoalTraining_1' name='txtOverviewFamilyInvolvementAssistIndividualMeetingGoalTraining_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>2.</td>
                        <td className='w-730'> <input type='text' id='txtOverviewFamilyInvolvementAssistIndividualMeetingGoalTraining_2' name='txtOverviewFamilyInvolvementAssistIndividualMeetingGoalTraining_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>3.</td>
                        <td className='w-730'> <input type='text' id='txtOverviewFamilyInvolvementAssistIndividualMeetingGoalTraining_3' name='txtOverviewFamilyInvolvementAssistIndividualMeetingGoalTraining_3' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>WITHIN THE PAST 30 DAYS RATIONAL HAVE THERE BEEN ANY CHANGES PUTTING THE INDIVIDUAL AT RISK FOR CRISIS INTERVENTIONS SUICIDAL, OR HOMICIDAL IDEATION, SELF-INJURIOUS BEHAVIORS THAT WOULD BE DEEMED AT RISK FOR HOSPITALIZATION OUT OF HOME OR COMMUNITY PLACEMENT AT RISK BEHAVIORS/HOSPITALIZATION OR OUT OF HOME PLACEMENT: (DESCRIBE WHAT HAPPENED OR WAS STATED BELOW):</b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>PROBLEM/NEEDS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>1.</td>
                        <td className='w-730'> <input type='text' id='txtPROBLEMNEEDS_1' name='txtPROBLEMNEEDS_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>2.</td>
                        <td className='w-730'> <input type='text' id='txtPROBLEMNEEDS_2' name='txtPROBLEMNEEDS_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>3.</td>
                        <td className='w-730'> <input type='text' id='txtPROBLEMNEEDS_3' name='txtPROBLEMNEEDS_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-20'>4.</td>
                        <td className='w-730'> <input type='text' id='txtPROBLEMNEEDS_4' name='txtPROBLEMNEEDS_4' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>{`Problem#1:`}</span>
                    <textarea id='txtProblem1' name='txtProblem1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>LONG TERM GOAL 1:</span>
                    <textarea id='txtLONGTERMGOAL1' name='txtLONGTERMGOAL1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Target Date:</span>
                    <input type='date' id='txtTargetDate_1' name='txtTargetDate_1' className='add-only' />
                </p>


                <p className='w-750'>
                    <b> Person Centered Goal:</b><input type='text' id='txtProviderName_' name='txtProviderName_' className='add-only w-550 custom-add-only' />
                </p>
                <p className='w-750'>
                    <h3>LIST SHORT TERM GOAL(S) WITH DURATION AND FREQUENCY</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 1.1</span>
                    <textarea id='txtObjective1_1' name='txtObjective1_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL1/OBJECTIVE 1.1</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective1_1' name='txtStatusProgressOnShortTermGoalObjective1_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 1.2</span>
                    <textarea id='txtObjective1_2' name='txtObjective1_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL1/OBJECTIVE 1.2</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective1_2' name='txtStatusProgressOnShortTermGoalObjective1_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 1.3</span>
                    <textarea id='txtObjective1_3' name='txtObjective1_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL1/OBJECTIVE 1.3</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective1_3' name='txtStatusProgressOnShortTermGoalObjective1_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>LACK OF PROGRESS WITHIN THE PAST 30 DAYS (INCLUDE A PLAN OF ACTION):</span>
                    <textarea id='txtLackOfProgressWithinThePastDaysIncludePlanOfAction1' name='txtLackOfProgressWithinThePastDaysIncludePlanOfAction1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`Problem#2:`}</span>
                    <textarea id='txtProblem2' name='txtProblem2' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>LONG TERM GOAL 2:</span>
                    <textarea id='txtLongTermGoal2' name='txtLongTermGoal2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Target Date:</span>
                    <input type='date' id='txtTargetDate_2' name='txtTargetDate_2' className='add-only' />
                </p>
                <p className='w-750'>
                    <b> Person Centered Goal:</b><input type='text' id='txtPersonCenteredGoal_2' name='txtPersonCenteredGoal_2' className='add-only w-550 custom-add-only' />
                </p>
                <p className='w-750'>
                    <h3>LIST SHORT TERM GOAL(S) WITH DURATION AND FREQUENCY</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 2.1</span>
                    <textarea id='txtObjective2_1' name='txtObjective2_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL2/OBJECTIVE 2.1</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective2_1' name='txtStatusProgressOnShortTermGoalObjective2_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 2.2</span>
                    <textarea id='txtObjective2_2' name='txtObjective2_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL2/OBJECTIVE 2.2</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective2_2' name='txtStatusProgressOnShortTermGoalObjective2_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 2.3</span>
                    <textarea id='txtObjective2_3' name='txtObjective2_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL2/OBJECTIVE 2.3</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective2_3' name='txtStatusProgressOnShortTermGoalObjective2_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>LACK OF PROGRESS WITHIN THE PAST 30 DAYS (INCLUDE A PLAN OF ACTION):</span>
                    <textarea id='txtLackOfProgressWithinThePastDaysIncludePlanOfAction2' name='txtLackOfProgressWithinThePastDaysIncludePlanOfAction2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`Problem#3:`}</span>
                    <textarea id='txtProblem3' name='txtProblem3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>LONG TERM GOAL 3:</span>
                    <textarea id='txtLongTermGoal3' name='txtLongTermGoal3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Target Date:</span>
                    <input type='date' id='txtTargetDate_3' name='txtTargetDate_3' className='add-only' />
                </p>

                <p className='w-750'>
                    <b> Person Centered Goal:</b><input type='text' id='txtPersonCenteredGoal_3' name='txtPersonCenteredGoal_3' className='add-only w-550 custom-add-only' />
                </p>
                <p className='w-750'>
                    <h3>LIST SHORT TERM GOAL(S) WITH DURATION AND FREQUENCY</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 3.1</span>
                    <textarea id='txtObjective3_1' name='txtObjective3_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL1/OBJECTIVE 3.1</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective3_1' name='txtStatusProgressOnShortTermGoalObjective3_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 3.2</span>
                    <textarea id='txtObjective3_2' name='txtObjective3_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL/OBJECTIVE 3.2</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective3_2' name='txtStatusProgressOnShortTermGoalObjective3_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 3.3</span>
                    <textarea id='txtObjective3_3' name='txtObjective3_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL1/OBJECTIVE 3.3</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective3_3' name='txtStatusProgressOnShortTermGoalObjective3_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>LACK OF PROGRESS WITHIN THE PAST 30 DAYS (INCLUDE A PLAN OF ACTION):</span>
                    <textarea id='txtLackOfProgressWithinThePastDaysIncludePlanOfAction3' name='txtLackOfProgressWithinThePastDaysIncludePlanOfAction3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`Problem#4:`}</span>
                    <textarea id='txtProblem4' name='txtProblem4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>LONG TERM GOAL 4:</span>
                    <textarea id='txtLongTermGoal4' name='txtLongTermGoal4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Target Date:</span>
                    <input type='date' id='txtTargetDate_4' name='txtTargetDate_4' className='add-only' />
                </p>

                <p className='w-750'>
                    <b> Person Centered Goal:</b><input type='text' id='txtPersonCenteredGoal_4' name='txtPersonCenteredGoal_4' className='add-only w-550 custom-add-only' />
                </p>
                <p className='w-750'>
                    <h3>LIST SHORT TERM GOAL(S) WITH DURATION AND FREQUENCY</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 4.1</span>
                    <textarea id='txtObjective4_1' name='txtObjective4_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL4/OBJECTIVE 4.1</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective4_1' name='txtStatusProgressOnShortTermGoalObjective4_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 4.2</span>
                    <textarea id='txtObjective4_2' name='txtObjective4_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL4/OBJECTIVE 4.2</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective4_2' name='txtStatusProgressOnShortTermGoalObjective4_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 4.3</span>
                    <textarea id='txtObjective4_3' name='txtObjective4_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL4/OBJECTIVE 4.3</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective4_3' name='txtStatusProgressOnShortTermGoalObjective4_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>LACK OF PROGRESS WITHIN THE PAST 30 DAYS (INCLUDE A PLAN OF ACTION):</span>
                    <textarea id='txtLackOfProgressWithinThePastDaysIncludePlanOfAction4' name='txtLackOfProgressWithinThePastDaysIncludePlanOfAction4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`Problem#5:`}</span>
                    <textarea id='txtProblem5' name='txtProblem5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>LONG TERM GOAL 5:</span>
                    <textarea id='txtLongTermGoal5' name='txtLongTermGoal5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Target Date:</span>
                    <input type='date' id='txtTargetDate_5' name='txtTargetDate_5' className='add-only' />
                </p>
                <p className='w-750'>
                    <b> Person Centered Goal:</b><input type='text' id='txtPersonCenteredGoal_5' name='txtPersonCenteredGoal_5' className='add-only w-550 custom-add-only' />
                </p>
                <p className='w-750'>
                    <h3>LIST SHORT TERM GOAL(S) WITH DURATION AND FREQUENCY</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 5.1</span>
                    <textarea id='txtObjective5_1' name='txtObjective5_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL4/OBJECTIVE 5.1</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective5_1' name='txtStatusProgressOnShortTermGoalObjective5_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 5.2</span>
                    <textarea id='txtObjective5_2' name='txtObjective5_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL4/OBJECTIVE 5.2</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective5_2' name='txtStatusProgressOnShortTermGoalObjective5_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Objective 5.3</span>
                    <textarea id='txtObjective5_3' name='txtObjective5_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STATUS: PROGRESS ON SHORT TERM GOAL4/OBJECTIVE 5.3</span>
                    <textarea id='txtStatusProgressOnShortTermGoalObjective5_3' name='txtStatusProgressOnShortTermGoalObjective5_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>LACK OF PROGRESS WITHIN THE PAST 30 DAYS (INCLUDE A PLAN OF ACTION):</span>
                    <textarea id='txtLackOfProgressWithinThePastDaysIncludePlanOfAction5' name='txtLackOfProgressWithinThePastDaysIncludePlanOfAction5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>
                        BARRIERS TO PROGRESS OF TREATMENT PLAN:
                    </h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>OTHER BARRIERS TO PROGRESS OF TREATMENT PLAN:</span>
                    <textarea id='txtOtherBarriersToProgressOfTreatmentPlan' name='txtOtherBarriersToProgressOfTreatmentPlan' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>INDIVIDUAL CURRENT STRENGTHS:</span>
                    <textarea id='txtIndividualCurrentStrengths' name='txtIndividualCurrentStrengths' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>INDIVIDUAL CURRENT RESOURCES:</span>
                    <textarea id='txtIndividualCurrentResources' name='txtIndividualCurrentResources' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>
                        TRANSITION PLAN: INCLUDE CURRENT PROVIDER & FUTURE PROVIDERS/SUPPORTS
                    </h3>
                    <span className='small'>{`(INCLUDE COMPLETE EXTERNAL PROVIDERS NAME ADDRESS AND PHONE#'S)`}</span>
                </p>
                <p className='w-750'>
                    The expected length of stay for this patient is Approx. 1 year. The projected discharge date for this patient is:
                    <input type='date' id='txtTransitionPlanIncludeFutureProvider' name='txtTransitionPlanIncludeFutureProvider' className='add-only w-200 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Refer to Outpatient Therapist or Facility:</span>
                    <textarea id='txtReferToOutpatientTherapistFacility' name='txtReferToOutpatientTherapistFacility' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Refer to Psychiatrist/Prescriber/PCP:</span>
                    <textarea id='txtReferToPsychiatristPrescriberPCP' name='txtReferToPsychiatristPrescriberPCP' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Refer to Social Agency Community Supports:</span>
                    <textarea id='txtReferToSocialAgencyCommunitySupports' name='txtReferToSocialAgencyCommunitySupports' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other Community Supports:</span>
                    <textarea id='txtOtherCommunitySupports' name='txtOtherCommunitySupports' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Natural Supports:</span>
                    <textarea id='txtNaturalSupports' name='txtNaturalSupports' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Anticipated Post Discharge Services include:</span>
                    <textarea id='txtAnticipatedPostDischargeServicesInclude' name='txtAnticipatedPostDischargeServicesInclude' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Discharge Criteria:</span>
                    <textarea id='txtDischargeCriteria' name='txtDischargeCriteria' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    {`My signature below confirms the following: *The services recommended and ordered are medically necessary and can reasonably be expected to improve the patient's condition and that the patient continues to need the current level of psychiatric care. *`}
                </p>
                <p className='w-750'>
                    {`Signature below indicates that this Quarterly Progress has been reviewed and approved:`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Staff Signature: </td>
                        <td className='small w-250'> Credentials: </td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Staff Signature: </td>
                        <td className='small w-250'> Credentials: </td>
                        <td className='small w-250'> Date: </td>
                    </tr>
                </table>






            </div>
        </form>

    )
}